var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSatGuarante(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5453 37.9641H4.57129C4.57129 30.9252 9.7763 25.102 16.5473 24.1336M26.5274 10.02C26.5274 14.4294 22.9527 18.004 18.5433 18.004C14.1339 18.004 10.5593 14.4294 10.5593 10.02C10.5593 5.61052 14.1339 2.03595 18.5433 2.03595C22.9527 2.03595 26.5274 5.61052 26.5274 10.02Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3202 27.2157C25.3003 25.6012 27.9356 26.0755 29.516 27.8383C31.0963 26.0755 33.6975 25.6182 35.7117 27.2157C37.7257 28.8129 37.9705 31.529 36.4154 33.4382C35.5376 34.5162 33.4518 36.4058 31.8018 37.8471L31.8001 37.8486C31.0187 38.5312 30.6278 38.8726 30.1548 39.0124C29.7513 39.1316 29.2806 39.1316 28.8771 39.0124C28.4041 38.8726 28.0132 38.5312 27.2318 37.8486L27.2301 37.8471C25.5801 36.4058 23.4943 34.5162 22.6165 33.4382C21.0614 31.529 21.3403 28.8299 23.3202 27.2157Z",
    fill: "#CA0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatGuarante);
export default __webpack_public_path__ + "static/media/satGuarante.cb0be745e4866455b608d1686683e35a.svg";
export { ForwardRef as ReactComponent };